import { render, staticRenderFns } from "./BusinessNameFile.vue?vue&type=template&id=90ff4244&scoped=true&"
import script from "./BusinessNameFile.vue?vue&type=script&lang=js&"
export * from "./BusinessNameFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ff4244",
  null
  
)

export default component.exports